<template>
  <div class="subproperty-settings-page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="subpropertySettings.title"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="subproperty-settings__container">
        <el-row class="subproperty-settings__cards" :gutter="20">
          <el-col
            v-for="setting in settings"
            :key="setting.id"
            :lg="8" :md="12" :sm="24"
          >
            <router-link :to="setting.route">
              <div class="subproperty-settings__card">
                <div class="subproperty-settings__icon">
                  <i :class="setting.icon" />
                </div>
                <div class="subproperty-settings__title">
                  <span>{{ setting.title }}</span>
                </div>
                <el-tooltip
                  placement="right"
                  class="subproperty-settings__tooltip"
                >
                  <div slot="content" class="subproperty-settings__tooltip__content">
                    <span v-text="setting.tooltipCaption"></span>
                  </div>
                  <i
                    class="icon-info subproperty-settings__tooltip__icon"
                  /> 
                </el-tooltip>
                <div class="subproperty-settings__subtitle">
                  <span>{{ setting.subtitle }}</span>
                </div>
              </div>
            </router-link>
          </el-col>
        </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { SubpropertySettingsModel } from '@modules/subproperty-settings/subproperty-settings-model';
import { i18n } from '@shared/i18n';

export default {
  computed: {
    ...mapGetters({
      currentManage: 'auth/manage/currentManage',
      isPropertyNBA: 'auth/manage/isPropertyNBA',
    }),
    subproperty() {
      return this.currentManage.subproperty;
    },
    paymentsEnabled() {
      return this.subproperty.paymentsEnabled;
    },
    settings() {
      const { paymentsEnabled } = this;
      return SubpropertySettingsModel.settings({
        paymentsEnabled,
        propertyId: this.currentManage.property.id,
        subpropertyId: this.currentManage.subproperty.id,
        isPropertyNBA: this.isPropertyNBA,
      });
    },
  },
  methods: {
    i18n(code){
      return i18n(code)
    },
  },
};
</script>

<style scoped>
   .subproperty-settings__container {
    position: relative;
    margin-top: 16px;
    background: #fff;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    overflow: hidden;
  }

   .subproperty-settings__card {
    height: 100px;
    margin: 8px 0;
    padding: 2em;
    border: none;
    border-radius: 4px;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);

    display: grid;
    grid-template-areas:
      'icon title info'
      'icon subtitle .';
    grid-template-columns: 40px 1fr;
    grid-template-rows: 2fr 1fr;

    white-space: normal;
    cursor: pointer;
  }

  .subproperty-settings__icon,
  .subproperty-settings__icon:before,
  .subproperty-settings__icon:after {
    font-size: 25px;
    display: table;
    content: "";
    clear: both;
    grid-area: icon;

    margin: 0 0 0 2px;
  }

  .subproperty-settings__title {
    grid-area: title;
    font-size: 25px;
    width: min-content;
  }

  .subproperty-settings__cards {
    padding: 32px 40px;
  }

  .subproperty-settings__subtitle {
    grid-area: subtitle;
    font-size: 15px;
    color: #a5adbb;
  }

  .subproperty-settings__tooltip {
    grid-area: info;
    align-self: flex-start;
  }
  .subproperty-settings__tooltip__icon {
    color: #a5adbb;
  }
  .subproperty-settings__tooltip__content {
    width: 220px;
  }

  /* .subproperty-settings__links {
    grid-area: links;
    align-self: end;
  }
  .subproperty-settings__link {
    font-size: 14px;
    font-weight: bold;
    color: #2a2c3f;
    margin-right: 3em;
  } */

  .subproperty-settings-page__information {
    display: flex;
    align-items: center;
    padding: 2em 2em 0em 2.7em;

  }.subproperty-settings-page__information__icon {
    font-size: 28px;
    color: #a3a3a3;
    padding-right: 8px;
  }.subproperty-settings-page__information__message {
    font-size: 14px;
    color: #a3a3a3;
  }


</style>

